import React, { useState, useEffect } from "react";
import { getStudentIdData } from "../../../lib/studentbooklistview";
import { useParams } from "react-router-dom";
import Student911TopMenu from "../studentInfo/student911topmenu"
import PageNotes from "../../pages/common/pagenotesnew";
import { useAuth } from "../../../usercontext";

export default function InstructorStudentBookList() {
  const [studentBookList, setStudentBookList] = useState();
  const { profile, setProfile } = useAuth();
  let { slug } = useParams();

  async function GetData() {
    const info = await getStudentIdData(slug);
    setStudentBookList(info);
  }

  useEffect(() => {
    GetData();
  }, []);
  return (
    <>
      <Student911TopMenu slug={slug} activeMenu={"BookList"} />
      <PageNotes
        type={"Instructor"}
        pageName={"Readings"}
        studentId={slug}
        instructorId={profile.id}
      />
      <div className="tak-instruct-group">
        <div className="row">
          <div className="col-md-12">
            <div className="settings-widget">
              <div className="settings-inner-blk p-2">
                {/* <div className="checkout-form personal-address add-course-info"> */}
                  <div className="personal-info-head p-2">
                    <h3>List of Recommended Books</h3>
                  </div>
                  <div className="comman-space pb-0">
                    <div className="settings-referral-blk course-instruct-blk  table-responsive">
                      {/* Instructor Users */}
                      <table className="table table-nowrap mb-0">
                        <thead>
                          <tr>
                            <th>ID</th>
                            <th>TITLE</th>
                            <th>AUTHOR</th>
                            <th>STATUS</th>
                          </tr>
                        </thead>
                        <tbody>
                          {studentBookList
                            ? studentBookList.map(function (data) {
                                return (
                                  <tr key={data.bookId}>
                                    <td>{data.bookId}</td>
                                    <td>{data.title}</td>
                                    <td>{data.author}</td>
                                    <td>
                                      {data.isRead ? (
                                        <span className="badge info-low">
                                          Read
                                        </span>
                                      ) : (
                                        <span className="badge info-high">
                                          Not Yet
                                        </span>
                                      )}
                                    </td>
                                  </tr>
                                );
                              })
                            : ""}
                        </tbody>
                      </table>
                      {/* Instructor List */}
                    </div>
                  </div>
                {/* </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
